import React from "react"
import { withStyles } from '@material-ui/core';
import moment from "moment"
import "moment-timezone"
import PropertyFilterBar from "./propertyFilterBar"
import EventsFilterBar from "./eventsFilterBar"
import { getInviteesDefaultValue } from "./utils";
import { getMonthDates } from "content/utils/commonParsing"

const styles = () => ({
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
  }
})

class FilterBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      allEvents: [],
      eventsSelectedByTimeProperties: [],
      firstFilterValue: [],
      thirdFilterValue: [],
      loading: true,
    };
  }

  componentDidMount = () => {
    const { propertiesOfOrg, orgLevel, subOrgDetails } = this.props;
    if (orgLevel && propertiesOfOrg.length > 0 && this.state.firstFilterValue.length == 0) {
      this.handleChangeProperty([propertiesOfOrg[0].id]);
    } else {
      this.handleChangeProperty([subOrgDetails.id]);
    }
    this.setState({
      loading: false,
    });
  };

  componentDidUpdate = (prevProps) => {
    const { orgLevel, tabIndex } = this.props;
    if (prevProps.tabIndex !== this.props.tabIndex) {
      const { eventsSelectedByTimeProperties, thirdFilterValue } = this.state;
      if ((orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2)) {
        if (thirdFilterValue.length == 0 || thirdFilterValue[0].list.length == 0) {
          this.setState({
            thirdFilterValue: getInviteesDefaultValue(eventsSelectedByTimeProperties),
          });
        } else {
          this.setState({
            thirdFilterValue: [
              {
                ...thirdFilterValue[0],
                list: thirdFilterValue[0].list.slice(0, 1),
              },
            ],
          });
        }
      } else if (orgLevel && tabIndex == 1) {
        if (thirdFilterValue.length > 0 && thirdFilterValue[0].list.length == 0) {
          this.setState({
            thirdFilterValue: [],
          });
        }
      }
    }
  };

  getEventsByPropertyIdsSelected = (propertyIds, monthRange) => {
    const { allEventsByProperties, orgLevel, tabIndex } = this.props;
    let eventsById = JSON.stringify(
      allEventsByProperties && allEventsByProperties.filter((ele) => propertyIds.includes(ele.id))
    );
    eventsById = JSON.parse(eventsById);
    for (var i = 0; i < eventsById.length; i++) {
      let timeFiltered = eventsById[i].list.filter(
        (event) =>
          new Date(monthRange.startAt) <= new Date(event.startAt) &&
          new Date(monthRange.endAt) >= new Date(event.endAt)
      );
      eventsById[i].list = timeFiltered;
    }
    eventsById = eventsById.filter((e) => e.list.length > 0);
    let thirdFilterValue = [];
    if ((orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2)) {
      thirdFilterValue = getInviteesDefaultValue(eventsById);
    }
    this.setState({
      eventsSelectedByTimeProperties: eventsById,
      thirdFilterValue,
    });
  };

  handleChangeProperty = (selected) => {
    this.setState({
      firstFilterValue: selected,
    });
    this.getEventsByPropertyIdsSelected(selected, this.props.monthRange);
  };
  handleMonthRange = (time) => {
    this.props.setMonthRange(time);
    this.getEventsByPropertyIdsSelected(this.state.firstFilterValue, time);
  };
  handleChangeEvents = (selected) => {
    this.setState({
      thirdFilterValue: selected,
    });
  };

  handleResetClick = () => {
    const { subOrgDetails, orgLevel, propertiesOfOrg } = this.props;
    this.props.setMonthRange({
      startAt: moment().tz(subOrgDetails.timezoneString).startOf("month"),
      endAt: moment().tz(subOrgDetails.timezoneString).endOf("month"),
      label: "This Month",
    });
    if (orgLevel && propertiesOfOrg.length > 0) {
      this.handleChangeProperty([propertiesOfOrg[0].id]);
    } else {
      this.handleChangeProperty([subOrgDetails.id]);
    }
  };

  render() {
    const { firstFilterValue, thirdFilterValue, eventsSelectedByTimeProperties, loading } =
      this.state;
    const { tabIndex, monthRange, subOrgDetails, propertiesOfOrg, orgLevel, ...other } = this.props;
    if (loading) return null;
    if (orgLevel && tabIndex == 1) {
      return (
        <PropertyFilterBar
          propertiesOfOrg={propertiesOfOrg}
          firstFilterValue={firstFilterValue}
          thirdFilterValue={thirdFilterValue}
          eventsSelectedByTimeProperties={eventsSelectedByTimeProperties}
          monthRange={monthRange}
          subOrgDetails={subOrgDetails}
          handleChangeProperty={this.handleChangeProperty}
          handleMonthRange={this.handleMonthRange}
          handleChangeEvents={this.handleChangeEvents}
          handleResetClick={this.handleResetClick}
          orgLevel={orgLevel}
          tabIndex={tabIndex}
          fileName={`Events_Properties_Breakdown_${getMonthDates(monthRange)}.csv`}
          {...other}
        />
      );
    } else {
      return (
        <EventsFilterBar
          propertiesOfOrg={propertiesOfOrg}
          firstFilterValue={firstFilterValue}
          thirdFilterValue={thirdFilterValue}
          eventsSelectedByTimeProperties={eventsSelectedByTimeProperties}
          monthRange={monthRange}
          subOrgDetails={subOrgDetails}
          handleChangeProperty={this.handleChangeProperty}
          handleMonthRange={this.handleMonthRange}
          handleChangeEvents={this.handleChangeEvents}
          tabIndex={tabIndex}
          handleResetClick={this.handleResetClick}
          orgLevel={orgLevel}
          single={(orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2) ? true : false}
          fileName={`Events_${(orgLevel && tabIndex == 3) || (!orgLevel && tabIndex == 2)
            ? "Invitees_Status"
            : "Events_Breakdown"
            }_${getMonthDates(monthRange)}.csv`}
          {...other}
        />
      );
    }
  }
}
export default withStyles(styles)(FilterBar);